import { render, staticRenderFns } from "./SelectFormat.vue?vue&type=template&id=7459a28c&scoped=true"
import script from "./SelectFormat.vue?vue&type=script&lang=js"
export * from "./SelectFormat.vue?vue&type=script&lang=js"
import style0 from "./SelectFormat.vue?vue&type=style&index=0&id=7459a28c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7459a28c",
  null
  
)

export default component.exports